// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import DPBoundToControlTemplate from '@front/templates/DPBoundToControlTemplate.html';
import { DynPropertyControl } from '../elements/DynPropertyControl';
// TODO. Add 'set' functions to 'get-only' computed properties.
export class DPBoundToControl extends DynPropertyControl {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.observe('boundToItem', this.onBoundToItem);
    }
    onBoundToItem(item) {
        if (isNullOrUndefined(item))
            return;
        void this.set('dp.value', item.value);
    }
}
DynPropertyControl.extendWith(DPBoundToControl, {
    template: DPBoundToControlTemplate,
    data: function () {
        return {
            boundToItem: null
        };
    }
});
